import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Title from './components/Title';
import Header from './components/Header';
import Hero from './section/Hero';
import Clients from './section/Clients';
import About from './section/About';
import FeaturedServices from './section/FeaturedServices';
import Services from './section/Services';
import Contact from './section/Contact';
import Footer from './components/Footer';
import Main from './components/Main';
import Bed from './layanan/bed/Bed';
import HeaderSub from './components/HeaderSub';
import JadwalMain from './layanan/jadwal-dokter/Main';
import PendaftaranMain from './layanan/pendaftaran-online/Main';
import TelemedicMain from './layanan/telemedic/Main';
import InformasiMain from './layanan/informasi/Main';
import PengaduanMain from './layanan/pengaduan/Main';
import CtscanFasilitas from './fasilitas/ctscan';
import RontgenFasilitas from './fasilitas/rontgen';
import MammografiFasilitas from './fasilitas/mammografi';
import UsgFasilitas from './fasilitas/usg';
import LabpkFasilitas from './fasilitas/labpk';
import LabpaFasilitas from './fasilitas/labpa';
import ApotikFasilitas from './fasilitas/apotik';
import GigiFasilitas from './fasilitas/gigi';

const facilitiesRoutes = [
  { path: '/gigi', title: 'KLINIK GIGI DAN MULUT', Component: GigiFasilitas },
  { path: '/apotik', title: 'APOTIK', Component: ApotikFasilitas },
  {
    path: '/labpa',
    title: 'LABORATORIUM PATOLOGI ANATOMI',
    Component: LabpaFasilitas,
  },
  {
    path: '/labpk',
    title: 'LABORATORIUM PATOLOGI KLINIK',
    Component: LabpkFasilitas,
  },
  { path: '/usg', title: 'USG 4 DIMENSI', Component: UsgFasilitas },
  { path: '/mammografi', title: 'MAMMOGRAFI', Component: MammografiFasilitas },
  { path: '/rontgen', title: 'RONTGEN D-R & C-R', Component: RontgenFasilitas },
  {
    path: '/ctscan',
    title: 'CT-SCAN 128 SLICE CARDIO',
    Component: CtscanFasilitas,
  },
  { path: '/pengaduan', title: 'Pengaduan', Component: PengaduanMain },
  { path: '/informasi', title: 'Informasi', Component: InformasiMain },
  {
    path: '/telemedic',
    title: 'Sistem Konsultasi Medis Online (SI KOMEDO)',
    Component: TelemedicMain,
  },
  {
    path: '/pendaftaran-online',
    title: 'Pendaftaran Online',
    Component: PendaftaranMain,
  },
  { path: '/jadwal-dokter', title: 'Jadwal Dokter', Component: JadwalMain },
];

function WithHeaderFooter({ title, children }) {
  return (
    <>
      <HeaderSub pageTitle={title} />
      {children}
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router basename="/build">
      <Title />
      <div>
        <Routes>
          {facilitiesRoutes.map(({ path, title, Component }) => (
            <Route
              key={path}
              path={path}
              element={
                <WithHeaderFooter title={title}>
                  <Component />
                </WithHeaderFooter>
              }
            />
          ))}
          <Route path="/bed" element={<Bed />} />

          <Route
            path="/"
            element={
              <>
                <Header />
                <main className="main">
                  <Hero />
                  <Clients />
                  <About />
                  <Services />
                  <FeaturedServices />
                  <Contact />
                </main>
                <Footer />
                <Main />
              </>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
